/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './integration-template.reducer';

export const IntegrationTemplateDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const integrationTemplateEntity = useAppSelector(state => state.integrationTemplate.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="integrationTemplateDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.integrationTemplate.detail.title">IntegrationTemplate</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.name}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.code">Code</Translate>
            </span>
            <UncontrolledTooltip target="code">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.code" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.code}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.description}</dd>
          <dt>
            <span id="messageFormat">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.messageFormat">Message Format</Translate>
            </span>
            <UncontrolledTooltip target="messageFormat">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.messageFormat" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.messageFormat}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{integrationTemplateEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.integrationTemplate.channel">Channel</Translate>
          </dt>
          <dd>{integrationTemplateEntity.channel ? integrationTemplateEntity.channel.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/integration-template" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/integration-template/${integrationTemplateEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntegrationTemplateDetail;
